function o_MMS_Admin_Index_Methods(engine) {
  this.engine = engine;
}

o_MMS_Admin_Index_Methods.prototype = {
  // 获取登陆信息，得益于MVVM + Octopus故全部操作可在引擎内完成，而无需操作DOM对象。
  get: function () {

  },
  // 自动登陆模块
  auto: function () {

  }
}

export {
  o_MMS_Admin_Index_Methods
}





// WEBPACK FOOTER //
// ./src/assets/octopus/methods/MMS/Admin/Index.js